import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useModalStore } from '@/store/useModalStore';
import styles from './index.module.scss';

export default function AixueModalMask() {
  const { modalMaskOpen, modalMaskText, closeModalMask } = useModalStore();
  const root = typeof document !== 'undefined' ? document.body : null;
  // 禁止底层滚动穿透：根据 open 状态锁定/恢复 body，始终保持 Hook 顺序稳定
  useEffect(() => {
    if (!root) return;
    const prevOverflow = root.style.overflow;
    const prevTouchAction = root.style.touchAction as string;
    if (modalMaskOpen) {
      root.style.overflow = 'hidden';
      root.style.touchAction = 'none';
    } else {
      root.style.overflow = prevOverflow;
      root.style.touchAction = prevTouchAction;
    }
    return () => {
      root.style.overflow = prevOverflow;
      root.style.touchAction = prevTouchAction;
    };
  }, [modalMaskOpen, root]);
  if (!root || !modalMaskOpen) return null;
  
  return createPortal(
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>AI学就爱学·你的专属AI一对一导师</div>
        <div className={styles.body}>
          <div className={`${styles.qr} ${modalMaskText === "download-center" ? styles[`qr-download-center`] : ""}`}></div>
          <div className={styles.desc}>扫码{modalMaskText === "download-center" ? "下载爱学App" : ""}</div>
        </div>
        <div aria-label="close" onClick={closeModalMask} className={styles.close}></div>
      </div>
    </div>,
    root
  );
}


